// extracted by mini-css-extract-plugin
export var progressBar = "_fj-0";
export var progressBarInner = "_fj-1";